import { SVGProps, Ref, forwardRef } from 'react';

export const RotateLeftFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="m14.236 6-1.46-1.46c1.536.008 2.728.042 3.69.171 1.262.17 1.996.49 2.533 1.026.537.537.856 1.271 1.026 2.533.173 1.288.175 2.984.175 5.366H22v-.068c0-2.299 0-4.116-.191-5.538-.197-1.461-.61-2.638-1.537-3.566s-2.104-1.34-3.566-1.537c-1.073-.144-2.373-.18-3.936-.188l1.466-1.466L12.964 0 9.327 3.636l3.637 3.637z"
            fill="currentColor"
        />
        <path d="M2 16.5C2 9.938 2.938 9 9.5 9s7.5.938 7.5 7.5-.937 7.5-7.5 7.5S2 23.063 2 16.5" fill="currentColor" />
    </svg>
));
RotateLeftFilledSize24Glyph.displayName = 'RotateLeftFilledSize24Glyph';
